import Column from '@amzn/meridian/column';
import React, { Fragment } from 'react';
import {
  ChatMessage,
  ChatMessageType,
  ChatParticipantType,
} from '../../../api/ContactListening/schema';
import { ChatMessageBox } from './ChatMessageBox';
import Row from '@amzn/meridian/row';
import Text from '@amzn/meridian/text';

export interface ChatMessageDisplayProps {
  chatMessage: ChatMessage;
  prevMessage?: ChatMessage;
  customerTimezone: string;
}

export const ChatMessageDisplay: React.FC<ChatMessageDisplayProps> = ({
  chatMessage,
  prevMessage,
  customerTimezone,
}) => {
  const getParticipantName = (
    message: ChatMessage | undefined
  ): string | undefined => {
    const isCustomer: boolean =
      message?.participant?.__typename === ChatParticipantType.CUSTOMER;
    return isCustomer
      ? message?.participant?.customerName
      : message?.participant?.name;
  };

  const constructMessageText = (
    message: ChatMessage,
    isCustomer: boolean
  ): JSX.Element => {
    if (message.type === ChatMessageType.MESSAGE) {
      if (message.chatText) {
        const sourceText = message.chatText?.text;
        const translatedText = message.translationList?.[0]?.text;
        return (
          <>
            <ChatMessageBox
              message={sourceText}
              translatedMessage={translatedText}
              isCustomer={isCustomer}
              chatType={message.type}
              timestamp={message.timestamp}
              timezone={customerTimezone}
            />
          </>
        );
      } else {
        return <></>;
      }
    } else if (message.type === ChatMessageType.CHAT_PARKED) {
      return (
        <ChatMessageBox
          message={message.chatText ? message.chatText.text : undefined}
          chatType={message.type}
        />
      );
    } else if (message.type === ChatMessageType.CHAT_TRANSFERRED) {
      return (
        <ChatMessageBox
          message={message.chatText ? message.chatText.text : undefined}
          chatType={message.type}
        />
      );
    } else {
      return (
        <ChatMessageBox
          chatType={message.type}
          stateType={message.stateChangeType}
        />
      );
    }
  };

  const sameParticipant: boolean = prevMessage
    ? prevMessage.type === ChatMessageType.MESSAGE &&
      getParticipantName(chatMessage) === getParticipantName(prevMessage)
    : false;
  const isCustomer: boolean =
    chatMessage?.participant?.__typename === ChatParticipantType.CUSTOMER;
  return (
    <Fragment>
      {sameParticipant
        ? ''
        : chatMessage.type === ChatMessageType.MESSAGE && (
            <Row
              width='100%'
              alignmentHorizontal={isCustomer ? 'start' : 'end'}
            >
              <Text type='b200' color='primary'>
                {getParticipantName(chatMessage)}
              </Text>
            </Row>
          )}
      <Column>{constructMessageText(chatMessage, isCustomer)}</Column>
    </Fragment>
  );
};
export default ChatMessageDisplay;
